<div class="ap-margin-bottom-3">
    {{ 'renovation.amount' | propertyTypePipe: (store.getPropertyType() | async) | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="renovationAmount"
    [helpText]="'property.renovation.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="property.renovation.amount.additional-info.text"
    contentKey="property.renovation.amount.additional-info.content"
    modalUrlKey="property.renovation.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
